export enum HistoryTableButtonTextEnum {
  Copy = 'Copy',
  Copied = 'Copied',
}
